import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const MailIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 21.121 14.818"
    >
      <g transform="translate(1.06 1.06)">
        <rect
          width="19"
          height="13.007"
          transform="translate(0 0)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1220.1,74.493l9.5,8.972,9.5-8.972"
          transform="translate(-1220.097 -74.493)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
